import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { setResponse } from "../Response/responseSlice";
import { setToast, setLoading, setModal } from "../uiSlice";
import { adminCampanias, adminEventos, clientesCampania, getCampanias, getEventosCampania, getHorariosCampania, getTipoCampania } from "Services/campania_service";

const initialState = {
    campanias: [],
    campania: {
        initialized: false,
        idCampania: null,
        idTipoCampania: -1,
        idMicroaprendizaje: -1,
        idCurso: -1,
        codTipoCampania: 'carga',
        fechaEnvio: null,
        titulo: null,
        estado: 1
    },
    tipoCampania: [],
    horariosCampania: [],
    dia: {},
    evento: {
        fechaInicio: null,
        fechaFin: null,
        titulo: '',
        idEventoCampania: null,
        descripcion: '',
        estado: 1,
        laboral: 1,
    },
    eventos: [],
}

export const campaniaSlice = createSlice({
    name: 'campania',
    initialState,
    reducers: {
        setCampanias: (state, action) => {
            state.campanias = action.payload;
        },
        setCampania: (state, action) => {
            state.campania = action.payload;
        },
        updateCampaniaField: (state, action) => {
            const { name, value } = action.payload;
            state.campania[name] = value;
        },
        setTipoCampania: (state, action) => {
            state.tipoCampania = action.payload;
        },
        setHorariosCampania: (state, action) => {
            state.horariosCampania = action.payload;
        },
        setDia: (state, action) => {
            state.dia = action.payload;
        },
        setEvento: (state, action) => {
            state.evento = action.payload;
        },
        setEventos: (state, action) => {
            state.eventos = action.payload;
        },
        resetCampania: (state) => {
            state.campania = initialState.campania;
        }
    }
});

export const fetchCampanias = createAsyncThunk(
    'campania/fetchCampanias',
    async (data, { dispatch }) => {
        const campaniaRes = await getCampanias(data);
        dispatch(setCampanias(campaniaRes));
    }
);

export const fetchTipoCampanias = createAsyncThunk(
    'campania/fetchTipoCampanias',
    async (data, { dispatch }) => {
        const tipoCampaniaRes = await getTipoCampania(data);
        dispatch(setTipoCampania(tipoCampaniaRes));
    }
);

export const mergeCampanias = createAsyncThunk(
    'campania/merge',
    async (data, { dispatch }) => {
        dispatch(setLoading(true));

        const campaniaRes = await adminCampanias(data);
        console.log('adminCampanias =>', campaniaRes);

        const idCampaniaFinal =
            data?.idCampania == null ? campaniaRes?.data : data?.idCampania;

        const needsExcel =
            data?.codTipoCampania === 'carga' ||
            data?.codTipoCampania === 'webinar' ||
            data?.codTipoCampania === 'info';

        const hasClientes = Array.isArray(data?.clientes) && data.clientes.length > 0;

        // ✅ Ejecutar carga clientes:
        // - En creación: si needsExcel && hasClientes
        // - En edición: SOLO si hasClientes (porque significa que subieron Excel nuevo)
        if (campaniaRes?.result && needsExcel && hasClientes && idCampaniaFinal) {
            const dataClientesCampania = {
                idCampania: idCampaniaFinal,
                idTipoCampania: data.idTipoCampania,
                idMicroaprendizaje: data.idMicroaprendizaje,
                codTipoCampania: data.codTipoCampania,
                usuario: data.usuario,
                clientes: data.clientes,
            };

            const clientesCampaniaRes = await clientesCampania(dataClientesCampania);
            console.log('clientesCampania =>', clientesCampaniaRes);

            // opcional: si falla la carga de clientes, se muestra el error
            if (!clientesCampaniaRes?.result) {
                dispatch(setResponse(clientesCampaniaRes));
                dispatch(setLoading(false));
                return;
            }
        }

        dispatch(resetCampania());
        dispatch(setResponse(campaniaRes));
        dispatch(setLoading(false));
        dispatch(setModal(false));
        dispatch(setToast(true));
        dispatch(fetchCampanias({ idCampania: null }));

        setTimeout(() => {
            dispatch(setToast(false));
        }, 3000);
    }
);

export const fetchHorarioCampania = createAsyncThunk(
    'campania/fetchHorarioCampanias',
    async (_, { dispatch }) => {
        const horariosCampania = await getHorariosCampania();
        dispatch(setHorariosCampania(horariosCampania));
        dispatch(setDia(horariosCampania[0]));
    }
);

export const fetchEventosCampanias = createAsyncThunk(
    'campania/fetchEventosCampanias',
    async (_, { dispatch }) => {
        const eventosCampaniaRes = await getEventosCampania();
        dispatch(setEventos(eventosCampaniaRes));
    }
);

export const mergeEvento = createAsyncThunk(
    'evento/merge',
    async (data, { dispatch }) => {
        dispatch(setLoading(true))
        const eventoRes = await adminEventos(data);
        dispatch(setResponse(eventoRes));
        dispatch(setLoading(false));
        dispatch(setModal(false));
        dispatch(setToast(true));
        dispatch(setEvento({ ...initialState.evento }));
        dispatch(fetchEventosCampanias());
        setTimeout(() => {
            dispatch(setToast(false));
        }, 3000);
    }
);

export const { setCampanias, setCampania, setTipoCampania, setHorariosCampania, setDia, setEvento, setEventos, updateCampaniaField, resetCampania } = campaniaSlice.actions;
export default campaniaSlice.reducer;